import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/* ------------------------------------------------------------------ */
/* Conceptos de nómina (devengados / deducciones)                      */
/* ------------------------------------------------------------------ */
export const getActiveConcepts = async () => {
    const { data } = await axios.get(`${API_URL}/payroll-concepts/active`);
    return data;
};

export const getAllConcepts = async () => {
    const { data } = await axios.get(`${API_URL}/payroll-concepts/all`);
    return data;
};

export const createConcept = async (concept) => {
    const { data } = await axios.post(`${API_URL}/payroll-concepts/create`, concept);
    return data;
};

export const updateConcept = async (id, payload) => {
    const { data } = await axios.patch(`${API_URL}/payroll-concepts/update/${id}`, payload);
    return data;
};

export const deleteConcept = async (id) => {
    const { data } = await axios.delete(`${API_URL}/payroll-concepts/delete/${id}`);
    return data;
};

export const initializeConcepts = async () => {
    const { data } = await axios.post(`${API_URL}/payroll-concepts/initialize`);
    return data;
};

/* ------------------------------------------------------------------ */
/* Liquidaciones (payroll settlements)                                 */
/* ------------------------------------------------------------------ */
export const createSettlement = async (settlement) => {
    const { data } = await axios.post(`${API_URL}/payroll-settlements/create`, settlement);
    return data;
};

export const getSettlementsPaginated = async ({ page = 1, limit = 10, filters = {} } = {}) => {
    const { data } = await axios.post(`${API_URL}/payroll-settlements/paginated`, { page, limit, filters });
    return data;
};

export const updateSettlement = async (id, payload) => {
    const { data } = await axios.patch(`${API_URL}/payroll-settlements/update/${id}`, payload);
    return data;
};

export const deleteSettlement = async (id) => {
    const { data } = await axios.delete(`${API_URL}/payroll-settlements/delete/${id}`);
    return data;
};

export const loadToCostCenter = async (id, payload = {}) => {
    const { data } = await axios.post(`${API_URL}/payroll-settlements/${id}/load-cost-center`, payload);
    return data;
};

/* ------------------------------------------------------------------ */
/* Lavanderías (para elegir otro centro al cargar a costos)            */
/* ------------------------------------------------------------------ */
export const getLaundries = async () => {
    const { data } = await axios.post(`${API_URL}/laundry/filter`, {
        limit: 1000,
        offset: 1,
        query: { estado: 'Activa' },
    });
    return Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
};
